import { useQuery } from "@tanstack/react-query"

import boosterCouponApi from "./boosterCouponApi"

const useValidBoosterCouponQuery = (couponCode: string) => {
  const { data = false } = useQuery(["boosterCouponApi.valid", couponCode], () => boosterCouponApi.valid(couponCode), {
    enabled: couponCode !== "",
    select(result) {
      return result.isSuccess
    },
  })

  return data
}

export default useValidBoosterCouponQuery
